import { BrowserStorageService } from '@/services/BrowserStorage';
import { PortalJwtPayload } from '@/types';

export function parseJwtPayload(payload?: string | null): PortalJwtPayload {
  if (!payload) {
    const memoryPayload =
      BrowserStorageService.portalAccessToken.get() ||
      BrowserStorageService.portalAccessToken.get(true);

    if (!memoryPayload) {
      return {} as PortalJwtPayload;
    }

    return JSON.parse(window.atob(memoryPayload.split('.')[1]));
  }

  return JSON.parse(window.atob(payload.split('.')[1]));
}
